import { createIcon } from '@/utils/factoryUtil'

export const SVGCommonCards = createIcon('SVGCommonCards', (props) => (
  <svg viewBox='0 0 100 100' {...props}>
    <path d='M78.43,70.03L61.1,5.35c-.72-2.68-3.14-4.45-5.79-4.45-.51,0-1.04.07-1.56.21L10.86,12.6c-3.2.86-5.1,4.15-4.24,7.35l17.33,64.68c.72,2.68,3.14,4.45,5.79,4.45.51,0,1.04-.07,1.56-.21l42.89-11.49c3.2-.86,5.1-4.15,4.24-7.35ZM50.19,73.59c-9.78,2.62-21.14-8.06-25.37-23.86-4.23-15.8.26-30.73,10.04-33.35s21.14,8.06,25.37,23.86-.26,30.73-10.04,33.35Z' />
    <path d='M87.59,20.14h-13.21l12.75,47.57c1.04,3.87.5,7.91-1.5,11.38-2,3.47-5.24,5.95-9.11,6.99l-38.36,10.28c1.07,1.65,2.92,2.74,5.04,2.74h44.4c3.31,0,6-2.69,6-6V26.14c0-3.31-2.69-6-6-6Z' />
  </svg>
))
